// extracted by mini-css-extract-plugin
export var fileUpload = "_i5-1";
export var modalButton = "_i5-0";